/* eslint-disable react/prop-types */
import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import InfoGeneral from "../pages/InfoGeneral";
import AppLayout from "../components/AppLayout";
import LoginLayout from "../components/LoginLayout";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import Profile from "../pages/Profile";
import Ticketing from "../pages/Ticketing";
import Clientes from "../pages/Clientes";
import Subclientes from "../pages/Subclientes";
import Encuestas from "../pages/Encuestas";
import CalendarPage from "../pages/Calendar";
import CalendarReporting from "../pages/Calendar/Reporting";
import CalendarCentralizerPage from "../pages/Calendar/Centralizer";
import NotasDePedido from "../pages/NotasDePedido";
// import { NewOrderNoteProvider } from "../context/NewOrderNoteContext";
import EncuestaDetail from "../pages/EncuestaDetail";
import Error404 from "../pages/Error404";
import NovedadDetail from "../pages/NovedadDetail";
import FileManager from "../pages/FileManager";
import Inbox from "../pages/TicketDetail/Inbox";
import NotasDePedidoDetail from "../pages/NotasDePedidoDetail";
import Courses from "../pages/BackOfficeLab";
import NewCourse from "../pages/BackOfficeLab/NewCourse";
import PreviewCourse from "../pages/BackOfficeLab/NewCourse/preview";
import Segmentation from "../pages/BackOfficeLab/Segmentation";
import Candidatos from "../pages/Candidatos";
import ModuloOrdenesDeVenta from "../pages/ModuloOrdenesDeVenta";
import SubclientesInactivos from "../pages/Clientes/SubclientesInactivos";
// import TicketDetail from "../pages/TicketDetail";

function LoggedInRoute({ component: Component, children, allowLinkToken, ...rest }) {
  const { currentUser, linkToken } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        currentUser || (allowLinkToken && linkToken) ? (
          <AppLayout>{Component ? <Component /> : children}</AppLayout>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function LoggedOutRoute({ component: Component, children, ...rest }) {
  const { currentUser } = useAuth();

  return <Route {...rest} render={() => (!currentUser ? <LoginLayout>{Component ? <Component /> : children}</LoginLayout> : <Redirect to="/profile" />)} />;
}

const Routes = () => (
  <Switch>
    <LoggedOutRoute exact path="/login" component={Login} />
    <LoggedOutRoute exact path="/forgot" component={ForgotPassword} />
    <LoggedOutRoute exact path="/activation" component={ForgotPassword} />
    <LoggedInRoute exact path="/profile" component={Profile} />
    <LoggedInRoute exact path="/ticketing" component={Ticketing} />
    <LoggedInRoute exact path="/notasDePedido" component={NotasDePedido} />
    <LoggedInRoute exact path="/ordenesDeVenta" component={ModuloOrdenesDeVenta} />
    <LoggedInRoute exact path="/notasDePedido/:id/detail" component={NotasDePedidoDetail} />
    <LoggedInRoute exact path="/notasDePedido/:id/detail/:pagination" component={NotasDePedidoDetail} />
    <LoggedInRoute exact path="/candidatos" component={Candidatos} />
    <LoggedInRoute exact path="/ticketing/:id/detail/:pagination" component={Inbox} />
    <LoggedInRoute exact path="/ticketing/:id/detail" component={Inbox} />
    <LoggedInRoute exact path="/clientes" component={Clientes} />
    <LoggedInRoute exact path="/clientes/subclientes-inactivos" component={SubclientesInactivos} />
    <LoggedInRoute exact path="/infoGeneral" component={InfoGeneral} />
    <LoggedInRoute exact path="/subclientes" component={Subclientes} />
    <LoggedInRoute exact path="/encuestas" component={Encuestas} />
    <LoggedInRoute exact path="/calendar" component={CalendarPage} />
    <LoggedInRoute exact path="/calendar/reporting" component={CalendarReporting} />
    <LoggedInRoute exact path="/calendarCentralizer" component={CalendarCentralizerPage} />
    <LoggedInRoute exact path="/encuestas/:id/detail" component={EncuestaDetail} />
    <LoggedInRoute exact path="/novedad/:id/detail" component={NovedadDetail} />
    <LoggedInRoute exact allowLinkToken path="/filemanager" component={FileManager} />
    <LoggedInRoute exact path="/courses" component={Courses} />
    <LoggedInRoute exact path="/courses/new/:id?" component={NewCourse} />
    <LoggedInRoute exact path="/courses/new/:id/preview" component={PreviewCourse} />
    <LoggedInRoute exact path="/segmentation" component={Segmentation} />
    <Route exact path="/">
      <Redirect to="/login" />
    </Route>
    <Route component={Error404} />
  </Switch>
);

export default Routes;
